import styles from "./company-structure.module.css";
import { useState, useRef, useEffect } from "react";

import { Typography, Radio, Card, Tree, Flex, Spin, App } from "antd";

import { CHART_TYPES } from "@/constants/chart";

import { getTree } from "@/api/organizationalUnits";
import GoTree from "./GoTree";
import Breadcrumbs from "@/components/ui/Breadcrumbs";
import routes from "@/routes";

const { Title } = Typography;

const flattenTree = (tree) => {
  let result = [];

  const traverse = (node) => {
    if (!node.parent) {
      delete node.parent;
    }
    node.key = node.uuid;
    result.push(node);

    if (node.children) {
      node.children.forEach((child) => traverse(child));
    }
  };

  tree.forEach((node) => traverse(node));
  return result;
};

// Структура компании
// Отображает структуру компании
const CompanyStructure = () => {
  const { message } = App.useApp();

  // Данные
  const [tree, setTree] = useState();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const chartContainerRef = useRef(null);
  const [selectType, setSelectType] = useState("vertical");

  // Запрос на сервер для получения данных
  const fetchData = async () => {
    setIsLoading(true);

    try {
      const tree = await getTree();
      setTree(tree);

      setData(flattenTree(tree));
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setIsLoading(false);
    }
  };

  //  initial fetch
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        <Flex vertical gap={30} className={styles.page}>
          <Flex vertical gap={10}>
            <Breadcrumbs
              items={[
                {
                  title: "Главная",
                  href: routes.dashboards,
                },
                {
                  title: "Структура компании",
                },
              ]}
            />
            <Title level={2} className="no-margin">
              Структура компании
            </Title>
          </Flex>

          <Flex
            gap={20}
            align="center"
            justify="space-between"
            style={{ zIndex: 1 }}
          >
            <div className={styles.switchType}>
              {/* <span>Вид:</span> */}
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                value={selectType}
                onChange={(e) => setSelectType(e.target.value)}
              >
                {CHART_TYPES.map((type) => (
                  <Radio.Button key={type.key} value={type.key}>
                    {type.icon}
                    {/* {type.label} */}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </div>

            <Flex gap={10}>
              {/* <Button icon={<DownloadOutlined />} onClick={handleDownload}>
                Загрузить
              </Button> */}
              {/* <Button icon={<UploadOutlined />} onClick={handleDownload}>
                Скачать
              </Button> */}
            </Flex>
          </Flex>

          {selectType === "vertical" && (
            <div className={styles.wrap} ref={chartContainerRef}>
              <GoTree data={data} />
            </div>
          )}

          {selectType === "horizontal" && (
            <div className={styles.wrap} ref={chartContainerRef}>
              <GoTree data={data} vertical />
            </div>
          )}

          {selectType === "tree" && (
            <Card>
              <Tree
                // multiple={true}
                showLine={true}
                defaultExpandAll={true}
                treeData={tree}
                titleRender={(nodeData) => (
                  <div className={styles.treeNode}>
                    {nodeData.image && (
                      <img
                        alt=""
                        src={nodeData.image}
                        width="35"
                        style={{ borderRadius: "50%" }}
                      />
                    )}

                    <div className={styles.nodeText}>
                      <div className={styles.nodeTitle}>{nodeData.title}</div>
                      <div>{nodeData.name}</div>
                    </div>

                    {/* <div className={styles.nodeAction}>
                      <Dropdown
                        menu={{ items: itemsMenu, onClick: onClickMenu }}
                        trigger={["click"]}
                      >
                        <MoreOutlined />
                      </Dropdown>
                    </div> */}
                  </div>
                )}
              />
            </Card>
          )}
        </Flex>
      )}
    </>
  );
};

export default CompanyStructure;
